 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		7: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"8":"stencil-ion-action-sheet-ios-entry-js","9":"stencil-ion-action-sheet-md-entry-js","10":"stencil-ion-avatar_3-ios-entry-js","11":"stencil-ion-avatar_3-md-entry-js","12":"stencil-ion-back-button-ios-entry-js","13":"stencil-ion-back-button-md-entry-js","14":"stencil-ion-backdrop-ios-entry-js","15":"stencil-ion-backdrop-md-entry-js","16":"stencil-ion-button_2-ios-entry-js","17":"stencil-ion-button_2-md-entry-js","18":"stencil-ion-card_5-ios-entry-js","19":"stencil-ion-card_5-md-entry-js","20":"stencil-ion-checkbox-ios-entry-js","21":"stencil-ion-checkbox-md-entry-js","22":"stencil-ion-chip-ios-entry-js","23":"stencil-ion-chip-md-entry-js","24":"stencil-ion-col_3-entry-js","25":"stencil-ion-fab_3-ios-entry-js","26":"stencil-ion-fab_3-md-entry-js","27":"stencil-ion-img-entry-js","28":"stencil-ion-infinite-scroll_2-ios-entry-js","29":"stencil-ion-infinite-scroll_2-md-entry-js","30":"stencil-ion-input-ios-entry-js","31":"stencil-ion-input-md-entry-js","32":"stencil-ion-loading-ios-entry-js","33":"stencil-ion-loading-md-entry-js","34":"stencil-ion-modal-ios-entry-js","35":"stencil-ion-modal-md-entry-js","36":"stencil-ion-nav_2-entry-js","37":"stencil-ion-popover-ios-entry-js","38":"stencil-ion-popover-md-entry-js","39":"stencil-ion-progress-bar-ios-entry-js","40":"stencil-ion-progress-bar-md-entry-js","41":"stencil-ion-radio_2-ios-entry-js","42":"stencil-ion-radio_2-md-entry-js","43":"stencil-ion-range-ios-entry-js","44":"stencil-ion-range-md-entry-js","45":"stencil-ion-reorder_2-ios-entry-js","46":"stencil-ion-reorder_2-md-entry-js","47":"stencil-ion-ripple-effect-entry-js","48":"stencil-ion-route_4-entry-js","49":"stencil-ion-select_3-ios-entry-js","50":"stencil-ion-select_3-md-entry-js","51":"stencil-ion-spinner-entry-js","52":"stencil-ion-split-pane-ios-entry-js","53":"stencil-ion-split-pane-md-entry-js","54":"stencil-ion-tab-bar_2-ios-entry-js","55":"stencil-ion-tab-bar_2-md-entry-js","56":"stencil-ion-tab_2-entry-js","57":"stencil-ion-text-entry-js","58":"stencil-ion-textarea-ios-entry-js","59":"stencil-ion-textarea-md-entry-js","60":"stencil-ion-toast-ios-entry-js","61":"stencil-ion-toast-md-entry-js","62":"stencil-ion-toggle-ios-entry-js","63":"stencil-ion-toggle-md-entry-js","64":"stencil-ion-virtual-scroll-entry-js"}[chunkId]||chunkId) + "." + {"0":"636340ac","1":"c156a8ca","2":"ac67e2d1","3":"a71afa12","4":"02fdca8d","5":"ecf1c377","8":"05fd7572","9":"04c35bcd","10":"9e2860f9","11":"fec7ee43","12":"afa4b9fc","13":"36f1e1c0","14":"bf778081","15":"1d51e512","16":"d11a2133","17":"15cc774b","18":"6a447d92","19":"99cdd417","20":"3eeeb75b","21":"86d22907","22":"800ffd11","23":"54068ce6","24":"638cef9e","25":"058b553f","26":"0f85f329","27":"e0e96ec6","28":"a2ec9a87","29":"83f52e4d","30":"a98b2d8a","31":"95b6b12d","32":"33e26cec","33":"7e5cfc2e","34":"ff6d518d","35":"c834d3e1","36":"57919ab9","37":"891cc7ed","38":"6f788995","39":"ecefce74","40":"0d3c249d","41":"d5c4ca88","42":"e461b1e2","43":"20abc6db","44":"7d54cd9f","45":"18289972","46":"b8acb473","47":"efd1a6bd","48":"0c9bc758","49":"0574fd48","50":"279568ed","51":"a4e08df4","52":"f901b4c4","53":"2f16c79a","54":"b6464df4","55":"9a25dbc3","56":"ac3076d3","57":"a5216465","58":"9fc06b6c","59":"6b189324","60":"4e09b2e7","61":"282e74c3","62":"d23de60a","63":"402fb834","64":"f23809d1","66":"0f1907e6","67":"a372952c","68":"1269856a","69":"11f6e040","70":"2a8e9cec","71":"5486da6a","72":"f66c5f60","73":"ef2cbd05","74":"6041a4e4","75":"0e4b7c4b","76":"3642db5c","77":"f692b7c0","78":"6ddbb5da","79":"56b3b939","80":"47367f5a","81":"175d6411","82":"ed2b0849","83":"a306e1ec","84":"205b9640","85":"b6fc9462","86":"a0d777fc","87":"acb42239","88":"ef4895d9","89":"15901dc3","90":"9e9d8576","91":"948084d5"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonpionic-auth-firebase"] = this["webpackJsonpionic-auth-firebase"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
